import {NpsTranslation} from "../interfaces/NpsTranslationData";

export const getCommentQuestion = (questions: NpsTranslation | undefined, reason: number): string => {
    if (!questions) return '';

    switch (reason) {
        case 1:
            return questions.Question2;
        case 2:
            return questions.Question3;
        case 3:
            return questions.TellAboutProblem;
        case 4:
            return questions.WhatWrong;
        case 5:
        case 6:
            return questions.LeaveComment;
        default:
            return questions.Question1;
    }
}
